import { createSelector } from "@reduxjs/toolkit";

import { IUserEmergencyContact } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { dataSelector, buildData } from "../helpers";

export const userEmergencyContactsSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.userEmergencyContact) as IUserEmergencyContact[]
);

const dataUserEmergencyContactsSelector = createSelector(
  dataSelector,
  data => data.userEmergencyContact
);

export const userEmergencyContactSelectorCreator = (id: string) =>
  createSelector(dataUserEmergencyContactsSelector, data => {
    const item = data?.[API_ENDPOINTS.USER_EMERGENCY_CONTACT(id)];
    return item ? buildSingleItem(item) : undefined;
  });
